import React from "react";

import Background from "../../../assets/dinner/dinner-bg-01.png";
import Image from "../../../assets/dinner/dinner-choice-b.png";

import GamePageLayout from "../GamePageLayout";

const DinnerPage4 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("cleaning-1")}
    >
      퇴근하고 귀찮아 죽겠는데
      <br />
      떡볶이 어떻게 만들어~
      <br />
      호다닥 포장해가야지!
    </GamePageLayout>
  );
};

export default DinnerPage4;
